import { IsoTimestampSchema } from "./string-validation"
import { z } from 'zod'

/**
 * Prescription Status Schema
 * Reflects Pharmacy Hub fulfillment states
 */
export const PrescriptionStatusSchema = z
  .enum(['pending', 'ordered', 'received', 'declined', 'dispensed', 'shipped', 'delivered', 'lost'])
  .meta({ id: 'PrescriptionStatus' })

export type PrescriptionStatus = z.infer<typeof PrescriptionStatusSchema>

/**
 * Prescription Schema
 */
export const PrescriptionSchema = z
  .object({
    id: z.string(),
    orderId: z.string(),
    patientId: z.string(),
    patientName: z.string().optional(),
    rxNumber: z.string().optional(),
    status: PrescriptionStatusSchema,
    orderedAt: IsoTimestampSchema.optional(),
    dispensedAt: IsoTimestampSchema.optional(),
    shippedAt: IsoTimestampSchema.optional(),
    deliveredAt: IsoTimestampSchema.optional(),
    trackingNumber: z.string().optional(),
    scriptDuration: z.number().int().positive().optional(), // Days of supply
    supplyEndDate: z.iso.date().optional(),
  })
  .meta({ id: 'Prescription' })

export type Prescription = z.infer<typeof PrescriptionSchema>

/**
 * Prescription Filters Schema
 */
export const PrescriptionFiltersSchema = z
  .object({
    status: PrescriptionStatusSchema.optional(),
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(50),
  })
  .meta({ id: 'PrescriptionFilters' })

export type PrescriptionFilters = z.infer<typeof PrescriptionFiltersSchema>
